import { render } from "./QuickAccessSkeleton.vue?vue&type=template&id=64067c1c&scoped=true"
import script from "./QuickAccessSkeleton.vue?vue&type=script&lang=js"
export * from "./QuickAccessSkeleton.vue?vue&type=script&lang=js"

import "./QuickAccessSkeleton.vue?vue&type=style&index=0&id=64067c1c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64067c1c"]])

export default __exports__